import React from 'react';
import PropTypes from 'prop-types';

import OELicensingAccessProvider from '../../react-oe/oe-licensing-access-provider';
import OEToolbox from '../../lib/tools/oe-toolbox';
import {OEViewType} from '../../lib/oe-types';
import {OEStdCapBarTargetTypeFlags} from '../bars/cap/std/oe-std-cap-bar-model';
import {OECapBarPropTypes, OECapBarConfigFactory} from '../bars/cap/oe-cap-bar-model'
import {OEStdCapBarPropTypes} from '../bars/cap/std/oe-std-cap-bar-model';
import OEStdCapBarController from '../bars/cap/std/oe-std-cap-bar-controller';
import {OEFNStartSelectionModel} from '../views/flow-nav/start-selection/oe-fn-start-selection-model';

export default class OEProtoCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.licensingAccess = OELicensingAccessProvider.defaultLicensingAccess();

        this.state = {
            targetTypes: this.createTargetTypes()
        };

        this.onLicensingAccess = this.onLicensingAccess.bind(this);

        this.targetTypeForTarget = this.targetTypeForTarget.bind(this);
        this.isTargetTypeDisabled = this.isTargetTypeDisabled.bind(this);
        this.onTargetBtnDisabledPressed = this.onTargetBtnDisabledPressed.bind(this);
        this.targetTypeTargetForTarget = this.targetTypeTargetForTarget.bind(this);
    }

    componentWillReceiveProps(nextProps)   {
        if(!OEToolbox.shallowEqual(nextProps.targetTypes, this.props.targetTypes, true) || !OEToolbox.shallowEqual(nextProps.targetTypeMap, this.props.targetTypeMap, true) ||
        nextProps.versionTargets !== this.props.versionTargets || nextProps.featureAccess !== this.props.featureAccess || nextProps.startSelectionData !== this.props.startSelectionData)  {

            this.setState({targetTypes: this.createTargetTypes(nextProps)});
        }
    }

    createTargetTypes(props)    {
        props = props || this.props;
    
        let targetTypes = props.targetTypes.filter(type => {
            if(props.targetTypeMap[type]) return true;
            console.log('Warning (OEProtoCapBar) - could not find target type - ' + type + ' - in mapping.');
            return false;
        });

        targetTypes = targetTypes.map(targetType => {
            let ret = Object.assign({id: targetType, targetMenuHidden: true}, props.targetTypeMap[targetType]);

            if(props.versionTargets && !ret.target)   {
                let target = props.versionTargets.defaultTargetForType(targetType);
                if(target)  ret.target = target;
            }

            let startSelection = ret.startSelection || (props.startSelectionData ? props.startSelectionData.choose(targetType) : undefined);
            let doStartSelection = OEFNStartSelectionModel.itemCount(startSelection) > 1 || ret.showAlwaysStartSelection;

            if(doStartSelection && props.featureAccess)    {
                doStartSelection = props.featureAccess.isTargetSelectionAvailableForLicensingAccess(this.licensingAccess, targetType)
            }

            ret.startSelection = doStartSelection ? startSelection : undefined;

            return ret;
        });
    
        return targetTypes;
    }

    onLicensingAccess(licensingAccess) {
        this.licensingAccess = licensingAccess;
        this.setState({targetTypes: this.createTargetTypes()});
    }

    render()    {
        return (
            <React.Fragment>
                <OELicensingAccessProvider moduleId={this.props.moduleId} omitUpdateOnRelease={true} onLicensingAccess={this.onLicensingAccess}/>
                <OEStdCapBarController
                    className={this.props.className}
                    moduleId={this.props.moduleId}
                    config={this.props.config}
                    targetTypes={this.state.targetTypes}
                    targetTypeForTarget={this.targetTypeForTarget}
                    isTargetTypeDisabled={this.isTargetTypeDisabled}
                    onTargetBtnPressed={this.props.onTargetBtnPressed}
                    onTargetBtnDisabledPressed={this.onTargetBtnDisabledPressed}
                    targetTypeTargetForTarget={this.targetTypeTargetForTarget}
                />
            </React.Fragment>
        );
    }

    targetTypeForTarget(target, sender) {
        if(this.props.targetTypeForTarget)  return this.props.targetTypeForTarget(target, sender);

        if(!this.props.versionTargets)  return target;
        let type = this.props.versionTargets.targetType(target);
        return type ? type : target;
    }

    isTargetTypeDisabled(targetTypeId, sender, licensingAccess)    {
        if(this.props.isTargetTypeDisabled)  return this.props.isTargetTypeDisabled(targetTypeId, sender, licensingAccess);

        if(!this.props.featureAccess)   return false;
        return !this.props.featureAccess.isModuleAvailableForLicensingAccess(licensingAccess, targetTypeId);
    }

    onTargetBtnDisabledPressed(targetType, target, sender)    {
        if(this.props.onTargetBtnDisabledPressed)  return this.props.onTargetBtnDisabledPressed(targetType, target, sender);

        if(!sender.oe.isReady())   return;

        let flags = typeof(targetType.flags) === 'number' ? targetType.flags : OEStdCapBarTargetTypeFlags.default;
        if(!sender.connected && (flags & OEStdCapBarTargetTypeFlags.disableUnconnected))  return;

        let view = OEViewType.getRef(OEViewType.freePremium, sender.props.appComponent);
        if(view && view.setOpen) view.setOpen(true);
    }

    targetTypeTargetForTarget(targetType, target, sender, licensingAccess)  {
        if(this.props.targetTypeTargetForTarget)  return this.props.targetTypeTargetForTarget(targetType, target, sender, licensingAccess);

        if(!licensingAccess.isValid && this.props.versionTargets)    return this.props.versionTargets.demoTargetForType(targetType.id);
    }
};

OEProtoCapBar.defaultProps = {
    className:                  '',
    moduleId:                   '',
    config:                     OECapBarConfigFactory.buildStdConfig(),
    targetTypes:                [],
    targetTypeMap:              {}
};

OEProtoCapBar.propTypes = {
    className:                  PropTypes.string,
    moduleId:                   PropTypes.string,
    config:                     OECapBarPropTypes.config,
    targetTypes:                PropTypes.arrayOf(PropTypes.string),
    targetTypeMap: PropTypes.objectOf(
        PropTypes.shape(Object.assign({}, OEStdCapBarPropTypes.targetTypeDecl, {id: PropTypes.string, showAlwaysStartSelection: PropTypes.bool}))
    ),
    targetTypeForTarget:        PropTypes.func,
    isTargetTypeDisabled:       PropTypes.func,
    onTargetBtnPressed:         PropTypes.func,
    onTargetBtnDisabledPressed: PropTypes.func,
    targetTypeTargetForTarget:  PropTypes.func,
    versionTargets:             PropTypes.object,
    featureAccess:              PropTypes.object,
    startSelectionData:         PropTypes.object
};